export interface HelpSection {
    id: string;
    title: string;
    paragraphs: string[];
    steps?: string[];
}
export interface HelpArticle {
    id: string;
    category: string;
    type: string;
    title: string;
    summary: string;
    keywords: string[];
    sections: HelpSection[];
    related: string[];
    routes: string[];
    destination?: string;
    reviewedAt: string;
    sources: string[];
    unavailable?: boolean;
}
export interface HelpCatalog {
    categories: { id: string; title: string }[];
    articles: HelpArticle[];
    exceptions: { route: string; reason: string }[];
}
export interface HelpState {
    article: string;
    query: string;
    category: string;
    type: string;
    follow: boolean;
    history: string[];
    cursor: number;
    positions: Record<string, number>;
    results: boolean;
}
export const initialHelpState = (): HelpState => ({ article: '', query: '', category: '', type: '', follow: true, history: [''], cursor: 0, positions: {}, results: false });
